export default "/images/5f6d4ab70df8c0f680498e7ef26d4e5a.avif";